/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Affiliation_AInputs */

const en_gc_resources_faq_affiliation_a = /** @type {(inputs: Gc_Resources_Faq_Affiliation_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. This is an independent learning site and browser workspace. GridCraft is developed by the upstream Storytold / ArtCraft project. Official downloads link directly to its GitHub releases.`)
};

const zh_gc_resources_faq_affiliation_a = /** @type {(inputs: Gc_Resources_Faq_Affiliation_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。这是独立学习网站与浏览器工作空间。GridCraft 由官方 Storytold / ArtCraft 项目开发，下载链接直接指向其 GitHub 发布页面。`)
};

/**
* | output |
* | --- |
* | "No. This is an independent learning site and browser workspace. GridCraft is developed by the upstream Storytold / ArtCraft project. Official downloads link ..." |
*
* @param {Gc_Resources_Faq_Affiliation_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_affiliation_a = /** @type {((inputs?: Gc_Resources_Faq_Affiliation_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Affiliation_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_affiliation_a(inputs)
	return zh_gc_resources_faq_affiliation_a(inputs)
});
export { gc_resources_faq_affiliation_a as "gc.resources.faq.affiliation.a" }